import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "bordered-tab-wrap" }
const _hoisted_5 = /*#__PURE__*/_createVNode("ul", {
  class: "nav nav-tabs",
  id: "myTab",
  role: "tablist"
}, [
  /*#__PURE__*/_createVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createVNode("button", {
      class: "nav-link active px-3",
      id: "chat-tab",
      "data-toggle": "tab",
      "data-target": "#receivedInvoices",
      type: "button",
      role: "tab",
      "aria-controls": "received",
      "aria-selected": "true"
    }, "Received")
  ]),
  /*#__PURE__*/_createVNode("li", {
    class: "nav-item",
    role: "presentation"
  }, [
    /*#__PURE__*/_createVNode("button", {
      class: "nav-link px-3",
      id: "workflow-tab",
      "data-toggle": "tab",
      "data-target": "#sentInvoices",
      type: "button",
      role: "tab",
      "aria-controls": "sent",
      "aria-selected": "false"
    }, " Sent")
  ])
], -1)
const _hoisted_6 = { class: "tab-content" }
const _hoisted_7 = {
  class: "tab-pane active p-0",
  id: "receivedInvoices",
  role: "tabpanel",
  "aria-labelledby": "received-tab"
}
const _hoisted_8 = { class: "row pt-2" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = {
  for: "invoiceStatus",
  class: "mb-0 me-2"
}
const _hoisted_11 = { value: "1" }
const _hoisted_12 = { value: "2" }
const _hoisted_13 = { value: "3" }
const _hoisted_14 = {
  key: 0,
  class: "card p-0"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_16 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_17 = { class: "table table-borderless mb-0" }
const _hoisted_18 = { class: "table-primary nowrap-text" }
const _hoisted_19 = { scope: "col" }
const _hoisted_20 = { scope: "col" }
const _hoisted_21 = { scope: "col" }
const _hoisted_22 = { scope: "col" }
const _hoisted_23 = { scope: "col" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  key: 0,
  class: "green-text"
}
const _hoisted_28 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_29 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_30 = { key: 1 }
const _hoisted_31 = { colspan: "5" }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = {
  class: "tab-pane px-0",
  id: "sentInvoices",
  role: "tabpanel",
  "aria-labelledby": "sent-tab"
}
const _hoisted_34 = { class: "row pt-2" }
const _hoisted_35 = { class: "d-flex align-items-center" }
const _hoisted_36 = {
  for: "invoiceStatus",
  class: "mb-0 me-2"
}
const _hoisted_37 = { value: "1" }
const _hoisted_38 = { value: "2" }
const _hoisted_39 = { value: "3" }
const _hoisted_40 = {
  key: 0,
  class: "card"
}
const _hoisted_41 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_42 = { class: "table-responsive my-2 font-12 border" }
const _hoisted_43 = { class: "table table-borderless mb-0" }
const _hoisted_44 = { class: "table-primary nowrap-text" }
const _hoisted_45 = { scope: "col" }
const _hoisted_46 = { scope: "col" }
const _hoisted_47 = { scope: "col" }
const _hoisted_48 = { scope: "col" }
const _hoisted_49 = { scope: "col" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 0 }
const _hoisted_52 = { key: 1 }
const _hoisted_53 = {
  key: 0,
  class: "green-text"
}
const _hoisted_54 = {
  key: 1,
  class: "yellow-text"
}
const _hoisted_55 = {
  key: 2,
  class: "yellow-text"
}
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { colspan: "5" }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "modal-wrap default-modal xl-size" }
const _hoisted_60 = {
  class: "modal fade",
  "data-backdrop": "static",
  "data-keyboard": "false",
  id: "selectedReceivedInvoice",
  tabindex: -1,
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_61 = { class: "modal-dialog modal-xl modal-dialog-centered" }
const _hoisted_62 = { class: "modal-content" }
const _hoisted_63 = { class: "modal-header" }
const _hoisted_64 = { class: "d-block" }
const _hoisted_65 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_66 = { class: "green-text" }
const _hoisted_67 = /*#__PURE__*/_createVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_68 = { class: "modal-body" }
const _hoisted_69 = { class: "card" }
const _hoisted_70 = { class: "row align-items-center" }
const _hoisted_71 = { class: "col-md-8" }
const _hoisted_72 = { class: "inline-items" }
const _hoisted_73 = { key: 0 }
const _hoisted_74 = { class: "green-text" }
const _hoisted_75 = {
  key: 0,
  class: "col-md-4"
}
const _hoisted_76 = { class: "text-md-right" }
const _hoisted_77 = {
  key: 0,
  class: "badge badge-dim badge-warning ml-1"
}
const _hoisted_78 = {
  key: 1,
  class: "badge badge-dim badge-warning ml-1 text-orange"
}
const _hoisted_79 = {
  key: 2,
  class: "badge badge-dim badge-warning ml-1 text-green"
}
const _hoisted_80 = {
  key: 3,
  class: "badge badge-dim badge-warning ml-1 text-red"
}
const _hoisted_81 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_82 = { class: "row" }
const _hoisted_83 = { class: "col-md-6" }
const _hoisted_84 = { key: 0 }
const _hoisted_85 = { key: 1 }
const _hoisted_86 = { key: 2 }
const _hoisted_87 = { key: 3 }
const _hoisted_88 = { key: 4 }
const _hoisted_89 = { key: 5 }
const _hoisted_90 = { class: "col-md-6" }
const _hoisted_91 = { key: 0 }
const _hoisted_92 = { key: 1 }
const _hoisted_93 = { key: 2 }
const _hoisted_94 = { key: 3 }
const _hoisted_95 = { key: 4 }
const _hoisted_96 = { key: 5 }
const _hoisted_97 = { class: "mt-4" }
const _hoisted_98 = { class: "table-responsive my-3 font-12" }
const _hoisted_99 = { class: "table table-bordered table-shadowed mb-0" }
const _hoisted_100 = { class: "table-primary nowrap-text" }
const _hoisted_101 = { scope: "col" }
const _hoisted_102 = { scope: "col" }
const _hoisted_103 = { scope: "col" }
const _hoisted_104 = { scope: "col" }
const _hoisted_105 = { class: "row" }
const _hoisted_106 = { class: "col-md-4 offset-md-8" }
const _hoisted_107 = { class: "shadowed-card" }
const _hoisted_108 = { class: "row" }
const _hoisted_109 = { class: "col-6" }
const _hoisted_110 = { class: "col-6 text-right" }
const _hoisted_111 = { key: 0 }
const _hoisted_112 = { key: 1 }
const _hoisted_113 = {
  key: 0,
  class: "col-6"
}
const _hoisted_114 = {
  key: 1,
  class: "col-6 text-right"
}
const _hoisted_115 = {
  key: 2,
  class: "col-6"
}
const _hoisted_116 = {
  key: 3,
  class: "col-6 text-right"
}
const _hoisted_117 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_118 = { class: "row" }
const _hoisted_119 = { class: "col-6" }
const _hoisted_120 = { class: "col-6 text-right" }
const _hoisted_121 = { key: 0 }
const _hoisted_122 = { key: 1 }
const _hoisted_123 = { class: "inline-items" }
const _hoisted_124 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EmptyData = _resolveComponent("EmptyData")
  const _component_big = _resolveComponent("big")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", null, [
      (_ctx.state.ui.isLoading.getSmartContractList)
        ? (_openBlock(), _createBlock("div", _hoisted_1, [
            _hoisted_2
          ]))
        : _createCommentVNode("", true),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _createVNode("div", _hoisted_8, [
                _createVNode("div", _hoisted_9, [
                  _createVNode("label", _hoisted_10, _toDisplayString(_ctx.$t('status')) + ":", 1),
                  _withDirectives(_createVNode("select", {
                    id: "invoiceStatus",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.state.data.filterReceivedInvoiceList.listByStatus = $event)),
                    onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.receivedInvocieByPhaseId && _ctx.receivedInvocieByPhaseId(...args))),
                    class: "form-control w-auto"
                  }, [
                    _createVNode("option", _hoisted_11, _toDisplayString(_ctx.$t('pending')), 1),
                    _createVNode("option", _hoisted_12, _toDisplayString(_ctx.$t('partial_paid')), 1),
                    _createVNode("option", _hoisted_13, _toDisplayString(_ctx.$t('paid')), 1)
                  ], 544), [
                    [_vModelSelect, _ctx.state.data.filterReceivedInvoiceList.listByStatus]
                  ])
                ])
              ]),
              (!_ctx.state.ui.isPostLoading.receivedInvocieByPhaseId)
                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode("div", _hoisted_16, [
                      _createVNode("table", _hoisted_17, [
                        _createVNode("thead", _hoisted_18, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_19, _toDisplayString(_ctx.$t('invoice_number')), 1),
                            _createVNode("th", _hoisted_20, _toDisplayString(_ctx.$t('tasks_included')), 1),
                            _createVNode("th", _hoisted_21, _toDisplayString(_ctx.$t('date')), 1),
                            _createVNode("th", _hoisted_22, _toDisplayString(_ctx.$t('status')), 1),
                            _createVNode("th", _hoisted_23, _toDisplayString(_ctx.$t('link')), 1)
                          ])
                        ]),
                        (
                                        _ctx.state.data.filterReceivedInvoiceList.list &&
                                        _ctx.state.data.filterReceivedInvoiceList.list.length
                                    )
                          ? (_openBlock(), _createBlock("tbody", _hoisted_24, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                                            .filterReceivedInvoiceList.list, (childPhase, childPhaseIndex) => {
                                return (_openBlock(), _createBlock("tr", { key: childPhaseIndex }, [
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(childPhase.invoice_no
                                                            ? childPhase.invoice_no
                                                            : _ctx.$t('n_a')), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(childPhase.title ? childPhase.title : _ctx.$t('n_a')), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    (childPhase.modifiedCreateddate)
                                      ? (_openBlock(), _createBlock("p", _hoisted_25, _toDisplayString(childPhase.modifiedCreateddate), 1))
                                      : (_openBlock(), _createBlock("p", _hoisted_26, _toDisplayString(childPhase.invoice_date
                                                            ? childPhase.invoice_date
                                                            : _ctx.$t('n_a')), 1))
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, [
                                      (childPhase.status === 3)
                                        ? (_openBlock(), _createBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('paid')), 1))
                                        : (childPhase.status === 1)
                                          ? (_openBlock(), _createBlock("span", _hoisted_28, _toDisplayString(_ctx.$t('pending')), 1))
                                          : (_openBlock(), _createBlock("span", _hoisted_29, _toDisplayString(_ctx.$t('partial_paid')), 1))
                                    ])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      id: "createNewProject",
                                      href: "javascript:void(0)",
                                      class: "btn default-btn mr-2 to-upper",
                                      onClick: ($event: any) => (_ctx.selectedInvoice(childPhase))
                                    }, _toDisplayString(_ctx.$t('view')), 9, ["onClick"]),
                                    _createVNode("a", {
                                      id: "createNewProject",
                                      href: "javascript:void(0)",
                                      class: "btn default-btn",
                                      onClick: ($event: any) => (_ctx.selectedPdf(childPhase.pdf_url))
                                    }, _toDisplayString(_ctx.$t('download')), 9, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("tfoot", _hoisted_30, [
                              _createVNode("tr", null, [
                                _createVNode("td", _hoisted_31, [
                                  _createVNode(_component_EmptyData, {
                                    title: _ctx.state.data.title,
                                    heading: _ctx.state.data.heading
                                  }, null, 8, ["title", "heading"])
                                ])
                              ])
                            ]))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_32, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('loading1')), 1)
                  ]))
            ]),
            _createVNode("div", _hoisted_33, [
              _createVNode("div", _hoisted_34, [
                _createVNode("div", _hoisted_35, [
                  _createVNode("label", _hoisted_36, _toDisplayString(_ctx.$t('status')) + ":", 1),
                  _withDirectives(_createVNode("select", {
                    id: "invoiceStatus",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.filterReceivedInvoiceList.listByStatus = $event)),
                    onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.receivedInvocieByPhaseId && _ctx.receivedInvocieByPhaseId(...args))),
                    class: "form-control w-auto"
                  }, [
                    _createVNode("option", _hoisted_37, _toDisplayString(_ctx.$t('pending')), 1),
                    _createVNode("option", _hoisted_38, _toDisplayString(_ctx.$t('partial_paid')), 1),
                    _createVNode("option", _hoisted_39, _toDisplayString(_ctx.$t('paid')), 1)
                  ], 544), [
                    [_vModelSelect, _ctx.state.data.filterReceivedInvoiceList.listByStatus]
                  ])
                ])
              ]),
              (!_ctx.state.ui.isPostLoading.receivedInvocieByPhaseId)
                ? (_openBlock(), _createBlock("div", _hoisted_40, [
                    _hoisted_41,
                    _createVNode("div", _hoisted_42, [
                      _createVNode("table", _hoisted_43, [
                        _createVNode("thead", _hoisted_44, [
                          _createVNode("tr", null, [
                            _createVNode("th", _hoisted_45, _toDisplayString(_ctx.$t('invoice_number')), 1),
                            _createVNode("th", _hoisted_46, _toDisplayString(_ctx.$t('tasks_included')), 1),
                            _createVNode("th", _hoisted_47, _toDisplayString(_ctx.$t('date')), 1),
                            _createVNode("th", _hoisted_48, _toDisplayString(_ctx.$t('status')), 1),
                            _createVNode("th", _hoisted_49, _toDisplayString(_ctx.$t('link')), 1)
                          ])
                        ]),
                        (
                                        _ctx.state.data.filterSentInvoiceList.list &&
                                        _ctx.state.data.filterSentInvoiceList.list.length
                                    )
                          ? (_openBlock(), _createBlock("tbody", _hoisted_50, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                                            .filterSentInvoiceList.list, (childPhase, childPhaseIndex) => {
                                return (_openBlock(), _createBlock("tr", { key: childPhaseIndex }, [
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(childPhase.invoice_no
                                                            ? childPhase.invoice_no
                                                            : _ctx.$t('n_a')), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, _toDisplayString(childPhase.title ? childPhase.title : _ctx.$t('n_a')), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    (childPhase.modifiedCreateddate)
                                      ? (_openBlock(), _createBlock("p", _hoisted_51, _toDisplayString(childPhase.modifiedCreateddate), 1))
                                      : (_openBlock(), _createBlock("p", _hoisted_52, _toDisplayString(childPhase.invoice_date
                                                            ? childPhase.invoice_date
                                                            : _ctx.$t('n_a')), 1))
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("p", null, [
                                      (childPhase.status === 3)
                                        ? (_openBlock(), _createBlock("span", _hoisted_53, _toDisplayString(_ctx.$t('paid')), 1))
                                        : (childPhase.status === 1)
                                          ? (_openBlock(), _createBlock("span", _hoisted_54, _toDisplayString(_ctx.$t('pending')), 1))
                                          : (_openBlock(), _createBlock("span", _hoisted_55, _toDisplayString(_ctx.$t('partial_paid')), 1))
                                    ])
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("a", {
                                      id: "createNewProject",
                                      href: "javascript:void(0)",
                                      class: "btn default-btn mr-2 to-upper",
                                      onClick: ($event: any) => (_ctx.selectedInvoice(childPhase))
                                    }, _toDisplayString(_ctx.$t('view')), 9, ["onClick"]),
                                    _createVNode("a", {
                                      id: "createNewProject",
                                      href: "javascript:void(0)",
                                      class: "btn default-btn",
                                      onClick: ($event: any) => (_ctx.selectedPdf(childPhase.pdf_url))
                                    }, _toDisplayString(_ctx.$t('download')), 9, ["onClick"])
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_openBlock(), _createBlock("tfoot", _hoisted_56, [
                              _createVNode("tr", null, [
                                _createVNode("td", _hoisted_57, [
                                  _createVNode(_component_EmptyData, {
                                    title: _ctx.state.data.title,
                                    heading: _ctx.state.data.heading
                                  }, null, 8, ["title", "heading"])
                                ])
                              ])
                            ]))
                      ])
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_58, [
                    _createVNode("p", null, _toDisplayString(_ctx.$t('loading1')), 1)
                  ]))
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_59, [
      _createVNode("div", _hoisted_60, [
        _createVNode("div", _hoisted_61, [
          _createVNode("div", _hoisted_62, [
            _createVNode("div", _hoisted_63, [
              _createVNode("div", _hoisted_64, [
                _createVNode("h5", _hoisted_65, [
                  _createVNode("strong", null, [
                    _createTextVNode(_toDisplayString(_ctx.$t('invoice_no')) + ": ", 1),
                    _createVNode("span", _hoisted_66, "#" + _toDisplayString(_ctx.state.data.selectedInvoice.invoice_no), 1)
                  ])
                ])
              ]),
              _createVNode("button", {
                type: "button",
                class: "close",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hideSelectedReceivedInvoice && _ctx.hideSelectedReceivedInvoice(...args))),
                "aria-label": "Close"
              }, [
                _hoisted_67
              ])
            ]),
            _createVNode("div", _hoisted_68, [
              _createVNode("div", _hoisted_69, [
                _createVNode("div", _hoisted_70, [
                  _createVNode("div", _hoisted_71, [
                    _createVNode("div", _hoisted_72, [
                      _createVNode("ul", null, [
                        _createVNode("li", null, [
                          (
                                                    _ctx.state.data.selectedInvoice &&
                                                    _ctx.state.data.selectedInvoice.invoice_date
                                                )
                            ? (_openBlock(), _createBlock("p", _hoisted_73, [
                                _createVNode(_component_big, null, {
                                  default: _withCtx(() => [
                                    _createVNode("strong", null, [
                                      _createTextVNode(_toDisplayString(_ctx.$t('invoice_date')) + ": ", 1),
                                      _createVNode("span", _hoisted_74, _toDisplayString(_ctx.state.data.selectedInvoice.invoice_date), 1)
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ])
                  ]),
                  (
                                    _ctx.state.data.selectedInvoice &&
                                    _ctx.state.data.selectedInvoice.status
                                )
                    ? (_openBlock(), _createBlock("div", _hoisted_75, [
                        _createVNode("div", _hoisted_76, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('status')) + " :", 1),
                            (_ctx.state.data.selectedInvoice.status === 1)
                              ? (_openBlock(), _createBlock("span", _hoisted_77, _toDisplayString(_ctx.$t('pending')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.selectedInvoice.status === 2)
                              ? (_openBlock(), _createBlock("span", _hoisted_78, _toDisplayString(_ctx.$t('partial_paid')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.selectedInvoice.status === 3)
                              ? (_openBlock(), _createBlock("span", _hoisted_79, _toDisplayString(_ctx.$t('paid')), 1))
                              : _createCommentVNode("", true),
                            (_ctx.state.data.selectedInvoice.status === 4)
                              ? (_openBlock(), _createBlock("span", _hoisted_80, _toDisplayString(_ctx.$t('draft')), 1))
                              : _createCommentVNode("", true)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_81,
                _createVNode("div", _hoisted_82, [
                  _createVNode("div", _hoisted_83, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, [
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('billed_from')) + " :", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    (
                                        _ctx.state.data.selectedInvoice.billed_from_user &&
                                        _ctx.state.data.selectedInvoice.billed_from_user.email
                                    )
                      ? (_openBlock(), _createBlock("p", _hoisted_84, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.email), 1))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.state.data.selectedInvoice.billed_from_user &&
                                        _ctx.state.data.selectedInvoice.billed_from_user.full_name
                                    )
                      ? (_openBlock(), _createBlock("p", _hoisted_85, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.full_name), 1))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.state.data.selectedInvoice.billed_from_user &&
                                        _ctx.state.data.selectedInvoice.billed_from_user
                                            .address_line1
                                    )
                      ? (_openBlock(), _createBlock("p", _hoisted_86, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user
                                                .address_line1), 1))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.state.data.selectedInvoice.billed_from_user &&
                                        _ctx.state.data.selectedInvoice.billed_from_user
                                            .address_line2
                                    )
                      ? (_openBlock(), _createBlock("p", _hoisted_87, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user
                                                .address_line2), 1))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.state.data.selectedInvoice.billed_from_user &&
                                        _ctx.state.data.selectedInvoice.billed_from_user.city
                                    )
                      ? (_openBlock(), _createBlock("p", _hoisted_88, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.city), 1))
                      : _createCommentVNode("", true),
                    (
                                        _ctx.state.data.selectedInvoice.billed_from_user &&
                                        _ctx.state.data.selectedInvoice.billed_from_user.country
                                    )
                      ? (_openBlock(), _createBlock("p", _hoisted_89, _toDisplayString(_ctx.state.data.selectedInvoice.billed_from_user.country), 1))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_90, [
                    _createVNode("p", null, [
                      _createVNode("strong", null, [
                        _createVNode(_component_big, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('billed_to')) + " :", 1)
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createVNode("div", null, [
                      (
                                            _ctx.state.data.selectedInvoice.billed_to_user &&
                                            _ctx.state.data.selectedInvoice.billed_to_user.email
                                        )
                        ? (_openBlock(), _createBlock("p", _hoisted_91, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.email), 1))
                        : _createCommentVNode("", true),
                      (
                                            _ctx.state.data.selectedInvoice.billed_to_user &&
                                            _ctx.state.data.selectedInvoice.billed_to_user.full_name
                                        )
                        ? (_openBlock(), _createBlock("p", _hoisted_92, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.full_name), 1))
                        : _createCommentVNode("", true),
                      (
                                            _ctx.state.data.selectedInvoice.billed_to_user &&
                                            _ctx.state.data.selectedInvoice.billed_to_user
                                                .address_line1
                                        )
                        ? (_openBlock(), _createBlock("p", _hoisted_93, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user
                                                    .address_line1), 1))
                        : _createCommentVNode("", true),
                      (
                                            _ctx.state.data.selectedInvoice.billed_to_user &&
                                            _ctx.state.data.selectedInvoice.billed_to_user
                                                .address_line2
                                        )
                        ? (_openBlock(), _createBlock("p", _hoisted_94, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user
                                                    .address_line2), 1))
                        : _createCommentVNode("", true),
                      (
                                            _ctx.state.data.selectedInvoice.billed_to_user &&
                                            _ctx.state.data.selectedInvoice.billed_to_user.city
                                        )
                        ? (_openBlock(), _createBlock("p", _hoisted_95, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.city), 1))
                        : _createCommentVNode("", true),
                      (
                                            _ctx.state.data.selectedInvoice.billed_to_user &&
                                            _ctx.state.data.selectedInvoice.billed_to_user.country
                                        )
                        ? (_openBlock(), _createBlock("p", _hoisted_96, _toDisplayString(_ctx.state.data.selectedInvoice.billed_to_user.country), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("p", _hoisted_97, [
                  _createVNode("strong", null, [
                    _createVNode(_component_big, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('title')) + " :", 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _createTextVNode(" " + _toDisplayString(_ctx.state.data.selectedInvoice.title), 1)
                ]),
                _createVNode("div", _hoisted_98, [
                  _createVNode("table", _hoisted_99, [
                    _createVNode("thead", _hoisted_100, [
                      _createVNode("tr", null, [
                        _createVNode("th", _hoisted_101, _toDisplayString(_ctx.$t('description')), 1),
                        _createVNode("th", _hoisted_102, _toDisplayString(_ctx.$t('cost_per_hour')), 1),
                        _createVNode("th", _hoisted_103, _toDisplayString(_ctx.$t('quantity_per_hour')), 1),
                        _createVNode("th", _hoisted_104, _toDisplayString(_ctx.$t('amount')), 1)
                      ])
                    ]),
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data
                                            .selectedInvoice.invoice_items, (invoiceDetail, invoiceDetailIndex) => {
                        return (_openBlock(), _createBlock("tr", { key: invoiceDetailIndex }, [
                          _createVNode("td", null, _toDisplayString(invoiceDetail.title), 1),
                          _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.cost), 1),
                          _createVNode("td", null, _toDisplayString(invoiceDetail.quantity), 1),
                          _createVNode("td", null, "$ " + _toDisplayString(invoiceDetail.amount), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_105, [
                  _createVNode("div", _hoisted_106, [
                    _createVNode("div", _hoisted_107, [
                      _createVNode("div", _hoisted_108, [
                        _createVNode("div", _hoisted_109, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(_ctx.$t('sub_total')), 1)
                          ])
                        ]),
                        _createVNode("div", _hoisted_110, [
                          (_ctx.state.data.selectedInvoice.sub_total)
                            ? (_openBlock(), _createBlock("p", _hoisted_111, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.sub_total), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_112, "$0"))
                        ]),
                        (_ctx.state.data.selectedInvoice.tax_amount)
                          ? (_openBlock(), _createBlock("div", _hoisted_113, [
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('tax')) + " (" + _toDisplayString(_ctx.state.data.selectedInvoice.tax) + "%)", 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.selectedInvoice.tax_amount)
                          ? (_openBlock(), _createBlock("div", _hoisted_114, [
                              _createVNode("p", null, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.tax_amount), 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.selectedInvoice.discount)
                          ? (_openBlock(), _createBlock("div", _hoisted_115, [
                              _createVNode("p", null, [
                                _createVNode("strong", null, _toDisplayString(_ctx.$t('discount')), 1)
                              ])
                            ]))
                          : _createCommentVNode("", true),
                        (_ctx.state.data.selectedInvoice.discount)
                          ? (_openBlock(), _createBlock("div", _hoisted_116, [
                              _createVNode("p", null, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.discount), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _hoisted_117,
                      _createVNode("div", _hoisted_118, [
                        _createVNode("div", _hoisted_119, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, [
                              _createVNode(_component_big, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('total')), 1)
                                ]),
                                _: 1
                              })
                            ])
                          ])
                        ]),
                        _createVNode("div", _hoisted_120, [
                          (
                                                    _ctx.state.data.selectedInvoice &&
                                                    _ctx.state.data.selectedInvoice.total
                                                )
                            ? (_openBlock(), _createBlock("p", _hoisted_121, " $" + _toDisplayString(_ctx.state.data.selectedInvoice.total), 1))
                            : (_openBlock(), _createBlock("p", _hoisted_122, "$0"))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_123, [
                  _createVNode("ul", null, [
                    (
                                        _ctx.state.data.selectedInvoice &&
                                        _ctx.state.data.selectedInvoice.pdf_url && (_ctx.state.data.selectedInvoice.user_id != _ctx.state.activeUserDetails.id)
                                    )
                      ? (_openBlock(), _createBlock("li", _hoisted_124, [
                          ( !(_ctx.projectStatus ==2))
                            ? (_openBlock(), _createBlock("a", {
                                key: 0,
                                id: "createNewProject",
                                href: "javascript:void(0)",
                                class: "btn default-btn mr-2",
                                onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.choosePaymentMode && _ctx.choosePaymentMode(...args)))
                              }, _toDisplayString(_ctx.state.ui.isPostLoading.confirmPayment
                                                    ? _ctx.$t('loading1')
                                                    : _ctx.$t('pay')), 1))
                            : _createCommentVNode("", true),
                          _createVNode("a", {
                            href: "javascript:void(0)",
                            class: "btn default-btn outline",
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedPdf(_ctx.state.data.selectedInvoice.pdf_url)))
                          }, _toDisplayString(_ctx.$t('download_pdf')), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}